module.exports = __webpack_public_path__ + "static/media/table-view.2010dd40.svg";